<div class="sub-menu-root-container system-menu-root-container"
    [style.width]="show ? 'var(--left-side-optionbar-width)' : '25px'">
    <div class="menu-list-container">

        <!-- <mat-list-item *ngIf="userData?.user_type === 'HQ' && hasAccess('department')" class="mat-list-item"
            routerLink="/system/department" [routerLinkActive]="['is-active']" [matTooltip]="!show ? 'Employee' : ''"
            matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/department.svg">
                <span class="master-title">Department</span>
            </div>
        </mat-list-item> -->

        <mat-list-item *ngIf="userData?.user_type === 'HQ' " class="mat-list-item" routerLink="/system/job-position"
            [routerLinkActive]="['is-active']" [matTooltip]="!show ? 'Job Position' : ''" matTooltipPosition="right"
            matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/job-position.svg">
                <span class="master-title">Job Position</span>
            </div>
        </mat-list-item>
        <mat-list-item *ngIf="userData?.user_type === 'HQ' " class="mat-list-item" routerLink="/system/employee-type"
            [routerLinkActive]="['is-active']" [matTooltip]="!show ? 'Employee Type' : ''" matTooltipPosition="right"
            matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img style="height: 20px;" src="assets/images/menu/svg/employee-type.svg">
                <span class="master-title">Employee Type</span>
            </div>
        </mat-list-item>
        <mat-list-item *ngIf="userData?.user_type === 'HQ' " class="mat-list-item" routerLink="/system/job-title"
            [routerLinkActive]="['is-active']" [matTooltip]="!show ? 'Job Title' : ''" matTooltipPosition="right"
            matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <mat-icon style="color: #666; font-size: 20px; width: 20px; height: 20px;">assignment_ind</mat-icon>
                <span class="master-title">Job Title</span>
            </div>
        </mat-list-item>
        <mat-list-item *ngIf="userData?.user_type === 'HQ' " class="mat-list-item" routerLink="/system/task"
            [routerLinkActive]="['is-active']" [matTooltip]="!show ? 'Task' : ''" matTooltipPosition="right"
            matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img style="height: 20px;" src="assets/images/menu/svg/task.svg">
                <span class="master-title">Task</span>
            </div>
        </mat-list-item>
        <mat-list-item *ngIf="userData?.user_type === 'HQ' " class="mat-list-item" routerLink="/system/shift"
            [routerLinkActive]="['is-active']" [matTooltip]="!show ? 'Shift' : ''" matTooltipPosition="right"
            matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <mat-icon style="color: #666; font-size: 20px; width: 20px; height: 20px;">schedule</mat-icon>
                <span class="master-title">Shift</span>
            </div>
        </mat-list-item>
        <mat-list-item *ngIf="userData?.user_type === 'HQ' " class="mat-list-item" routerLink="/system/leave-type"
            [routerLinkActive]="['is-active']" [matTooltip]="!show ? 'Leave Type' : ''" matTooltipPosition="right"
            matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <mat-icon style="color: #666; font-size: 20px; width: 20px; height: 20px;">event_busy</mat-icon>
                <span class="master-title">Leave Type</span>
            </div>
        </mat-list-item>
        <mat-list-item *ngIf="userData?.user_type === 'HQ' " class="mat-list-item" routerLink="/system/reason"
            [routerLinkActive]="['is-active']" [matTooltip]="!show ? 'Reason' : ''" matTooltipPosition="right"
            matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <mat-icon style="color: #666; font-size: 20px; width: 20px; height: 20px;">fact_check</mat-icon>
                <span class="master-title">Reason</span>
            </div>
        </mat-list-item>
        <mat-list-item *ngIf="userData?.user_type === 'HQ' " class="mat-list-item" routerLink="/system/settings"
            [routerLinkActive]="['is-active']" [matTooltip]="!show ? 'Settings' : ''" matTooltipPosition="right"
            matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <mat-icon style="color: #666; font-size: 20px; width: 20px; height: 20px;">settings</mat-icon>
                <span class="master-title">Settings</span>
            </div>
        </mat-list-item>

    </div>
</div>